<template>
  <section>
    <div class="tabs-wrapper">
      <b-tabs
        content-class="mb-0"
        :value="activeTabIndex"
        @input="onChangeTab"
      >
        <b-tab :title="$tk('ClientPortal.Catalogs.MyCatalogs')">
          <catalog-list v-if="visitedTabs.includes(0)" />
        </b-tab>
        <b-tab :title="$tk('ClientPortal.Catalogs.SharedCatalogs')">
          <shared-catalogs v-if="visitedTabs.includes(1)" />
        </b-tab>
        <b-tab :title="$tk('ClientPortal.Catalogs.CatalogSchemas')">
          <catalog-schema v-if="visitedTabs.includes(2)" />
        </b-tab>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import CatalogList from '@/views/client/properties/catalogs/CatalogList.vue'
import CatalogSchema from '@/views/client/properties/catalogs/CatalogSchema.vue'
import SharedCatalogs from '@/views/client/properties/catalogs/SharedCatalogs.vue'
import store from '@/store'

export default {
  components: {
    CatalogList,
    CatalogSchema,
    SharedCatalogs,
  },
  data() {
    return {
      visitedTabs: [],
      tabHashes: ['#catalog-list', '#shared-catalogs', '#catalog-schema-list'],
    }
  },
  computed: {
    activeTabIndex() {
      const route = this.$route.hash.toLowerCase()
      return this.tabHashes.findIndex(x => x === route) || 0
    },
  },
  mounted() {
    const route = this.$route.hash.toLowerCase()
    this.visitedTabs.push(this.tabHashes.findIndex(x => x === route) || 0)
  },
  methods: {
    onChangeTab(tab) {
      if (!this.visitedTabs.includes(tab)) {
        this.visitedTabs.push(tab)
      }
      store.commit('app/TOGGLE_NEW_CREATE_STATE', false)
      const hash = this.tabHashes[tab]
      this.$router.replace({ hash })
    },
  },
}
</script>
<style lang="scss" scoped>
  .tabs-wrapper {
    background-color: #ffffff;
    height: 20vh;
    border-radius: 4px;
    height: calc(100vh - 100px);
  }
</style>
